import {
  Box,
  Button,
  FormControl,
  FormErrorIcon,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Stack,
} from '@chakra-ui/react';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { Adult, ChevronRight } from '../../../../assets';
import { StepRuler } from './StepRuler';
import { useMobileCheckDepositContext } from '../../context';

export const DonorInfo: FC = () => {
  const {
    data: {
      steps: { activeStep, prevSteps },
    },
    commands: { handleNextStep, handleFormData, handleStep },
  } = useMobileCheckDepositContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const step = 0;
  const isActive = activeStep === 0;

  const hasStep = prevSteps.includes(step);
  const handleDonorInfo = () => {
    if (hasStep) {
      handleStep(step);
    }
  };

  const onSubmit = (data: any) => {
    handleFormData(data);
    handleNextStep();
  };

  return isActive ? (
    <Stack direction="row">
      <StepRuler icon={Adult} />
      <Stack spacing={4} w="full">
        <Heading fontSize="xl" color="brand.secondary.swatch4">
          Donor Information
        </Heading>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={4} alignSelf="flex-end" justifyContent="flex-end">
            <FormControl isInvalid={!!errors?.donorFirstName}>
              <FormLabel
                htmlFor="donorFirstName"
                color="brand.monochromatic.700"
              >
                Donor’s First Name
              </FormLabel>
              <Input
                id="donorFirstName"
                {...register('donorFirstName', {
                  required: 'First name is required',
                  minLength: {
                    value: 1,
                    message: 'Minimum length should be 1',
                  },
                  maxLength: {
                    value: 40,
                    message: 'Maximum length should be 40',
                  },
                })}
              />
              <FormErrorMessage>
                <>
                  <FormErrorIcon />
                  {errors?.donorFirstName?.message}
                </>
              </FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={!!errors?.donorLastName}>
              <FormLabel
                htmlFor="donorLastName"
                color="brand.monochromatic.700"
              >
                Donor’s Last Name
              </FormLabel>
              <Input
                id="donorLastName"
                {...register('donorLastName', {
                  required: 'Last name is required',
                  minLength: {
                    value: 1,
                    message: 'Minimum length should be 1',
                  },
                  maxLength: {
                    value: 40,
                    message: 'Maximum length should be 40',
                  },
                })}
              />
              <FormErrorMessage>
                <>
                  <FormErrorIcon />
                  {errors?.donorLastName?.message}
                </>
              </FormErrorMessage>
            </FormControl>
            <Box alignSelf="flex-end">
              <Button
                colorScheme="blue"
                type="submit"
                rightIcon={<ChevronRight boxSize={3} />}
              >
                Next
              </Button>
            </Box>
          </Stack>
        </form>
      </Stack>
    </Stack>
  ) : (
    <Button
      p={0}
      colorScheme="blue"
      variant="ghost"
      leftIcon={<Adult boxSize={6} />}
      onClick={handleDonorInfo}
      textDecoration={hasStep ? 'underline' : 'none'}
    >
      Donation Information
    </Button>
  );
};
